export const log = {
  error: (val: any, info?: any) => {
    console.error('val: ', val, info);
  },
  info: (val: any, info?: any) => {
    console.info('val: ', val, info);
  },
}

export default log